import React, { useState } from 'react'
import AssignmentOutlinedIcon from '@mui/icons-material/AssignmentOutlined'
import { Box, Stack, Typography } from '@mui/material'

import DropdownActionButton from '../components/action_button/DropdownActionButton'
import MobileEmptyStateCard from '../components/MobileEmptyStateCard'
import { MobileListItemCard } from '../components/mobile'
import PosTaskStatusChip from './PosTaskStatusChip'
import {
  checkValue,
  getClientOrAttribute,
  getFormattedDateOnly,
  getRecurrenceText,
  getTaskTypeLabel
} from './posTaskListHelpers'

const POS_TASK_MOBILE_ACCENT = '#597FA9'

const buildSummaryRows = (model) => [
  {
    label: 'Descripcion',
    value: checkValue(model.description),
    valueColor: '#0F1F33'
  },
  {
    label: 'Tipo',
    value: checkValue(getTaskTypeLabel(model.task_type)),
    valueColor: '#5F6F82'
  },
  {
    label: 'Cliente',
    value: checkValue(getClientOrAttribute(model)),
    valueColor: '#5F6F82'
  }
]

const buildDetailRows = (model) => [
  {
    detailRowKey: `${model.uuid}-recurrence`,
    label: 'Recurrencia',
    value: checkValue(getRecurrenceText(model)),
    valueColor: '#5F6F82'
  },
  {
    detailRowKey: `${model.uuid}-expires`,
    label: 'Expira',
    value: getFormattedDateOnly(model.end_date),
    valueColor: '#5F6F82'
  }
]

const buildFooter = (model) => (
  <Stack direction="row" alignItems="center" spacing={1} sx={{ minWidth: 0 }}>
    <Typography
      variant="caption"
      color="text.secondary"
      component="span"
      sx={{
        flexShrink: 0,
        fontSize: 14,
        fontWeight: 600,
        textTransform: 'uppercase',
        letterSpacing: 0.04
      }}
    >
      Estado:
    </Typography>
    <Box sx={{ minWidth: 0 }}>
      <PosTaskStatusChip status={model.status} className="pos-task-status--mobile-card" />
    </Box>
  </Stack>
)

const actionListFor = (model, onRequestClone, onRequestSuspend) => [
  {
    disabled: model.suspended,
    text: 'Suspender',
    handler: () => onRequestSuspend(model)
  },
  {
    text: 'Crear copia',
    handler: () => onRequestClone(model)
  }
]

export default function PosTaskMobileList({
  data,
  canWrite,
  onShow,
  onRequestClone,
  onRequestSuspend
}) {
  const [expandedTaskUuid, setExpandedTaskUuid] = useState(null)

  const toggleExpandedTask = (uuid) => {
    setExpandedTaskUuid((currentUuid) => (currentUuid === uuid ? null : uuid))
  }

  if (!data.length) {
    return (
      <Box sx={{ mt: 1 }}>
        <MobileEmptyStateCard
          icon={<AssignmentOutlinedIcon fontSize="small" />}
          title="No hay tareas en punto de venta disponibles"
          description=""
        />
      </Box>
    )
  }

  return (
    <Box className="pos-tasks-mobile-list">
      {data.map((model) => (
        <MobileListItemCard
          key={model.uuid}
          className="pos-task-card-grid"
          code={checkValue(model.short_uuid)}
          onCodeClick={() => onShow(model.uuid)}
          expanded={expandedTaskUuid === model.uuid}
          onToggleExpand={() => toggleExpandedTask(model.uuid)}
          summaryRows={buildSummaryRows(model)}
          detailRows={buildDetailRows(model)}
          accentColor={POS_TASK_MOBILE_ACCENT}
          codeAccentColor={POS_TASK_MOBILE_ACCENT}
          detailDividerColor="#E0E0E0"
          contentClassName="pos-task-card__content"
          headerClassName="pos-task-card__header"
          codeClassName="pos-task-card__code"
          summaryClassName="pos-task-card__summary"
          summaryRowClassName="pos-task-card__summary-row"
          summaryLabelClassName="pos-task-card__summary-label"
          summaryValueClassName="pos-task-card__summary-value"
          footerContent={buildFooter(model)}
          actionContent={
            canWrite ? (
              <Box className="pos-task-card-dropdown-wrap">
                <DropdownActionButton
                  id={`btn-dropdown-${model.uuid}`}
                  list={actionListFor(model, onRequestClone, onRequestSuspend)}
                />
              </Box>
            ) : null
          }
          actionPlacement="footer"
          footerDivider
          footerDividerColor="#E0E0E0"
          footerPaddingTop={1.5}
          expandAriaLabel={
            expandedTaskUuid === model.uuid
              ? 'Ocultar detalle de la tarea'
              : 'Mostrar detalle de la tarea'
          }
          detailRegionAriaLabel={`Detalle de la tarea ${model.short_uuid}`}
          summaryLabelFontSize={14}
          summaryValueFontSize={14}
          detailLabelFontSize={14}
          detailValueFontSize={14}
          bodyFontSize={14}
          codeFontSize={16}
        />
      ))}
    </Box>
  )
}
